import { render, staticRenderFns } from "./ActivationToggle.vue?vue&type=template&id=54671f08&"
import script from "./ActivationToggle.vue?vue&type=script&lang=js&"
export * from "./ActivationToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports